import { useState } from "react";
import { useAuth } from "./lib/auth-context";
import { GlobalStyle, Nav, NavCtx } from "./components/shared";
import type { Lot } from "./lib/api";

import { HomePage, OriginsPage, LotDetailPage, MembershipPage } from "./pages/public";
import { AuthPage } from "./pages/auth";
import { MemberDash } from "./pages/member";
import { AdminPayments } from "./pages/payments";
import {
  AdminShell, AdminDash, AdminLots, AdminOrders, AdminMembers, AdminSommeliers,
} from "./pages/admin";

const ADMIN_VIEWS = ["admin-dash", "admin-lots", "admin-orders", "admin-members", "admin-sommeliers", "admin-payments"];

export default function App() {
  const { user, loading } = useAuth();
  const [view,        setView]        = useState("home");
  const [selectedLot, setSelectedLot] = useState<Lot | null>(null);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#1a3028" }}>
        <div style={{ fontFamily: "'Cinzel',serif", fontSize: ".8rem", letterSpacing: ".38em", textTransform: "uppercase", color: "#b5913a" }}>Provenance</div>
      </div>
    );
  }

  const isAdminView = ADMIN_VIEWS.includes(view);

  const effectiveView = (() => {
    if (isAdminView && user?.role !== "admin") return "login";
    if (view === "member-dash" && !user) return "login";
    return view;
  })();

  const renderContent = () => {
    switch (effectiveView) {
      case "home":        return <HomePage />;
      case "origins":     return <OriginsPage />;
      case "lot-detail":  return <LotDetailPage />;
      case "membership":  return <MembershipPage />;
      case "login":       return <AuthPage mode="login" />;
      case "signup":      return <AuthPage mode="signup" />;
      case "member-dash": return <MemberDash />;

      case "admin-dash":
        return <AdminShell activeTab="admin-dash"><AdminDash /></AdminShell>;
      case "admin-lots":
        return <AdminShell activeTab="admin-lots"><AdminLots /></AdminShell>;
      case "admin-orders":
        return <AdminShell activeTab="admin-orders"><AdminOrders /></AdminShell>;
      case "admin-members":
        return <AdminShell activeTab="admin-members"><AdminMembers /></AdminShell>;
      case "admin-sommeliers":
        return <AdminShell activeTab="admin-sommeliers"><AdminSommeliers /></AdminShell>;
      case "admin-payments":
        return <AdminShell activeTab="admin-payments"><AdminPayments /></AdminShell>;

      default:
        return <HomePage />;
    }
  };

  return (
    <NavCtx.Provider value={{ view: effectiveView, setView, selectedLot, setSelectedLot }}>
      <GlobalStyle />
      {!isAdminView && <Nav />}
      {renderContent()}
    </NavCtx.Provider>
  );
}
